var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "optix-lab-analyzer" },
    [
      _c("div", { staticClass: "step-progress-bar mb-4" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-between align-items-center" },
          [
            _c("div", [
              _c("h5", { staticClass: "font-weight-bold mb-1" }, [
                _vm._v("\n          " + _vm._s(_vm.stepTitle) + "\n        "),
              ]),
              _vm._v(" "),
              _vm.currentStep === 1
                ? _c("p", { staticClass: "text-muted mb-0" }, [
                    _vm._v(
                      "\n          Test content with A/B comparisons and audience-specific analysis\n        "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "step-indicators" },
              _vm._l(3, function (n) {
                return _c("span", {
                  key: n,
                  staticClass: "step-dot",
                  class: {
                    active: n === _vm.currentStep,
                    completed: n < _vm.currentStep,
                  },
                })
              }),
              0
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.currentStep === 1
        ? _c(
            "div",
            { staticClass: "step-content" },
            [
              _c(
                "b-form-group",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-items-center gap-2",
                              },
                              [_c("span", [_vm._v("Analysis Type:")])]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    358086733
                  ),
                },
                [
                  _vm._v(" "),
                  _c("Multiselect", {
                    attrs: {
                      label: "name",
                      "track-by": "id",
                      "allow-empty": false,
                      options: _vm.promptOptions,
                      disabled:
                        _vm.customPrompts.length === 0 ||
                        _vm.customPrompts[0] === "loading",
                    },
                    model: {
                      value: _vm.selectedPrompt,
                      callback: function ($$v) {
                        _vm.selectedPrompt = $$v
                      },
                      expression: "selectedPrompt",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: !_vm.selectedPrompt,
                      },
                      on: { click: _vm.nextStep },
                    },
                    [
                      _vm._v("\n        Next "),
                      _c("i", { staticClass: "fas fa-arrow-right ml-2" }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.currentStep === 2
        ? _c(
            "div",
            { staticClass: "step-content" },
            [
              _vm.isVisualPlayBookAnalysis
                ? _c("div", { staticClass: "visual-playbook-section" }, [
                    _c(
                      "div",
                      { staticClass: "rounded border p-3 mb-3" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Select Input Type:" } },
                          [
                            _c("b-form-radio-group", {
                              staticClass: "w-100",
                              attrs: {
                                options: [
                                  { value: "search", text: "Search Term" },
                                  { value: "category", text: "Category URL" },
                                  {
                                    value: "products",
                                    text: "Specific Product URLs",
                                  },
                                ],
                                buttons: "",
                                "button-variant": "outline-primary",
                              },
                              model: {
                                value: _vm.inputMode,
                                callback: function ($$v) {
                                  _vm.inputMode = $$v
                                },
                                expression: "inputMode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputMode === "search"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "rounded border d-flex p-3 mb-3 align-items-center gap-2",
                          },
                          [
                            _c("p", { staticClass: "text-nowrap mb-0 mr-2" }, [
                              _vm._v(
                                "\n          Enter search keyword\n        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: { placeholder: "Enter search keyword" },
                              model: {
                                value: _vm.searchInput,
                                callback: function ($$v) {
                                  _vm.searchInput = $$v
                                },
                                expression: "searchInput",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm.inputMode === "category"
                      ? _c(
                          "div",
                          { staticClass: "rounded border p-3 mb-3" },
                          [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(
                                "\n          Enter Category URLs\n        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("b-form-textarea", {
                              ref: "categoryUrlsTextarea",
                              attrs: {
                                placeholder: "Enter one category URL per line",
                                rows: "3",
                              },
                              on: {
                                input: _vm.handleCategoryUrlsInput,
                                keyup: _vm.handleCategoryUrlsInput,
                                change: _vm.handleCategoryUrlsInput,
                                paste: _vm.handleCategoryUrlsPaste,
                              },
                              model: {
                                value: _vm.categoryUrlsText,
                                callback: function ($$v) {
                                  _vm.categoryUrlsText = $$v
                                },
                                expression: "categoryUrlsText",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "small",
                              { staticClass: "text-muted mt-1 d-block" },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.categoryUrls.length) +
                                    " URLs entered\n        "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm.inputMode === "products"
                      ? _c(
                          "div",
                          { staticClass: "rounded border p-3 mb-3" },
                          [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(
                                "\n          Enter Product URLs or ASINs (one per line, max 5)\n        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("b-form-textarea", {
                              ref: "productUrlsTextarea",
                              attrs: {
                                placeholder:
                                  "Enter one URL or ASIN per line (max 5)",
                                rows: "5",
                              },
                              on: {
                                input: _vm.handleProductUrlsInput,
                                keyup: _vm.handleProductUrlsInput,
                                change: _vm.handleProductUrlsInput,
                                paste: _vm.handleProductUrlsPaste,
                              },
                              model: {
                                value: _vm.productUrlsText,
                                callback: function ($$v) {
                                  _vm.productUrlsText = $$v
                                },
                                expression: "productUrlsText",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "small",
                              { staticClass: "text-muted mt-1 d-block" },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.productUrls.length) +
                                    "/5 items entered\n          "
                                ),
                                _vm.allProductUrls.length > 5
                                  ? _c("span", { staticClass: "text-danger" }, [
                                      _vm._v(
                                        " - Too many items! Only first 5 will be used."
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.inputMode !== "products"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "rounded border d-flex p-3 mb-3 align-items-center gap-2",
                          },
                          [
                            _c("p", { staticClass: "text-nowrap mb-0 mr-2" }, [
                              _vm._v(
                                "\n          Number of processed results\n        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Number of processed results",
                              },
                              model: {
                                value: _vm.countResults,
                                callback: function ($$v) {
                                  _vm.countResults = $$v
                                },
                                expression: "countResults",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "rounded border d-flex p-3 mb-3 align-items-center gap-2",
                      },
                      [
                        _c("p", { staticClass: "text-nowrap mb-0 mr-2" }, [
                          _vm._v(
                            "\n          Max Images Per Product\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("b-form-input", {
                          attrs: {
                            placeholder: "Number of max images per product",
                          },
                          model: {
                            value: _vm.maxImagesPerProduct,
                            callback: function ($$v) {
                              _vm.maxImagesPerProduct = $$v
                            },
                            expression: "maxImagesPerProduct",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputMode === "search" || _vm.inputMode === "category"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "rounded border d-flex p-3 mb-3 align-items-center gap-2",
                          },
                          [
                            _c(
                              "b-form-group",
                              { attrs: { label: "Retailers:" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.retailers,
                                    "value-field": "id",
                                    "text-field": "name",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "first",
                                        fn: function () {
                                          return [
                                            _c(
                                              "b-form-select-option",
                                              { attrs: { value: null } },
                                              [
                                                _vm._v(
                                                  "\n                Select a retailer\n              "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    282052679
                                  ),
                                  model: {
                                    value: _vm.selectedRetailer,
                                    callback: function ($$v) {
                                      _vm.selectedRetailer = $$v
                                    },
                                    expression: "selectedRetailer",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _c(
                    "b-tabs",
                    {
                      attrs: { "content-class": "mt-3" },
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    [
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: "Upload Files",
                            active: _vm.activeTab === 0,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              ref: "uploadContainer",
                              staticClass: "upload-container",
                              attrs: { tabindex: "0" },
                            },
                            [
                              _c("p", { staticClass: "text-center mb-3" }, [
                                _vm._v(
                                  "\n            Upload Images or Choose from File Browser\n          "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "paste-instruction" },
                                [
                                  _c("b-icon", {
                                    attrs: { icon: "clipboard" },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "Paste image(s) from clipboard (Ctrl+V)"
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.uploadedFilesCount > 0
                                ? _c(
                                    "div",
                                    { staticClass: "upload-count" },
                                    [
                                      _c(
                                        "b-badge",
                                        { attrs: { variant: "success" } },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.uploadedFilesCount) +
                                              " file(s) uploaded\n            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dropzone-container",
                                  class: {
                                    loading: _vm.isLoadingFileBrowserFiles,
                                  },
                                },
                                [
                                  _c("VueDropzone", {
                                    key: "imageUploadDropzone",
                                    ref: "fileDropzone",
                                    attrs: {
                                      id: "imageUploadDropzone",
                                      options: _vm.dropzoneOptions,
                                    },
                                    on: {
                                      "vdropzone-file-added": _vm.onFileAdded,
                                      "vdropzone-removed-file":
                                        _vm.onFileRemoved,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.isLoadingFileBrowserFiles
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "file-browser-loading-overlay",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "loading-content" },
                                            [
                                              _c("b-spinner", {
                                                staticClass: "mr-2",
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  "Loading selected files..."
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    size: "sm",
                                    variant: "outline-secondary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openSelectFolderModal(
                                        "default"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("b-icon", {
                                    staticClass: "mr-1",
                                    attrs: { icon: "folder" },
                                  }),
                                  _vm._v(
                                    "\n            File browser\n          "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: "URLs/ASINs",
                            active: _vm.activeTab === 1,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "url-input-section" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Enter URL, ASIN, or TCIN",
                                    description:
                                      "You can enter multiple items separated by spaces or line breaks",
                                  },
                                },
                                [
                                  _c("b-form-textarea", {
                                    attrs: {
                                      placeholder:
                                        "Enter URLs, ASINs, or TCINs (one per line or space-separated)",
                                      rows: "6",
                                    },
                                    model: {
                                      value: _vm.urlInput,
                                      callback: function ($$v) {
                                        _vm.urlInput = $$v
                                      },
                                      expression: "urlInput",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: "Quick Start",
                            active: _vm.activeTab === 2,
                          },
                        },
                        [
                          _c("div", { staticClass: "quick-start-section" }, [
                            _c(
                              "div",
                              { staticClass: "quick-start-options mb-3" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "mb-2 mr-2",
                                    attrs: {
                                      variant: "outline-secondary",
                                      disabled: _vm.isLoadingPreviousImages,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.usePreviousImages(0)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-history mr-2",
                                    }),
                                    _vm._v(
                                      "\n              Use Previous Images\n              "
                                    ),
                                    _vm.isLoadingPreviousImages
                                      ? _c("b-spinner", {
                                          staticClass: "ml-2",
                                          attrs: { small: "" },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "mb-2 mr-2",
                                    attrs: {
                                      variant: "outline-secondary",
                                      disabled: _vm.isLoadingPreviousImages,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.usePreviousImages(1)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-link mr-2",
                                    }),
                                    _vm._v(
                                      "\n              Use Previous ASIN/URL\n              "
                                    ),
                                    _vm.isLoadingPreviousImages
                                      ? _c("b-spinner", {
                                          staticClass: "ml-2",
                                          attrs: { small: "" },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "product-list-section border rounded p-3",
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-6" },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Select from Product List:",
                                          },
                                        },
                                        [
                                          _c("Multiselect", {
                                            attrs: {
                                              options: _vm.productListOptions,
                                              multiple: true,
                                              searchable: true,
                                              loading:
                                                _vm.isLoadingProductLists,
                                              disabled:
                                                _vm.isLoadingProductLists,
                                              "track-by": "id",
                                              label: "name",
                                              placeholder:
                                                "Choose product lists",
                                            },
                                            on: {
                                              input: _vm.loadProductsFromLists,
                                            },
                                            model: {
                                              value: _vm.selectedProductLists,
                                              callback: function ($$v) {
                                                _vm.selectedProductLists = $$v
                                              },
                                              expression:
                                                "selectedProductLists",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.availableProducts.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "col-md-6" },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label:
                                                  "Select Individual Products:",
                                              },
                                            },
                                            [
                                              _c(
                                                "Multiselect",
                                                {
                                                  attrs: {
                                                    options:
                                                      _vm.availableProducts,
                                                    multiple: true,
                                                    searchable: true,
                                                    disabled:
                                                      _vm.isLoadingProducts,
                                                    loading:
                                                      _vm.isLoadingProducts,
                                                    "close-on-select": false,
                                                    "track-by": "id",
                                                    label: "display_name",
                                                    placeholder:
                                                      "Select specific products",
                                                    "allow-empty": true,
                                                    limit: 3,
                                                    "limit-text": _vm.limitText,
                                                    "max-height": 300,
                                                  },
                                                  on: {
                                                    input:
                                                      _vm.populateSelectedProducts,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "option",
                                                        fn: function (props) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "multiselect-option",
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      props
                                                                        .option
                                                                        .display_name
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-muted d-block",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        props
                                                                          .option
                                                                          .product_list_name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    2136968834
                                                  ),
                                                  model: {
                                                    value: _vm.selectedProducts,
                                                    callback: function ($$v) {
                                                      _vm.selectedProducts = $$v
                                                    },
                                                    expression:
                                                      "selectedProducts",
                                                  },
                                                },
                                                [
                                                  _vm._v(" "),
                                                  _c(
                                                    "template",
                                                    { slot: "noResult" },
                                                    [
                                                      _vm._v(
                                                        "\n                      No products found\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "mt-2" },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        variant:
                                                          _vm.selectedProducts
                                                            .length ===
                                                          _vm.availableProducts
                                                            .length
                                                            ? "primary"
                                                            : "outline-primary",
                                                        size: "sm",
                                                        disabled:
                                                          _vm.isLoadingProducts ||
                                                          _vm.availableProducts
                                                            .length === 0,
                                                      },
                                                      on: {
                                                        click: _vm.selectAll,
                                                      },
                                                    },
                                                    [
                                                      _c("b-icon", {
                                                        attrs: {
                                                          icon:
                                                            _vm.selectedProducts
                                                              .length ===
                                                            _vm
                                                              .availableProducts
                                                              .length
                                                              ? "check-square"
                                                              : "square",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        " Select All\n                    "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.selectedProducts.length >
                                                  0
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          attrs: {
                                                            variant:
                                                              "outline-danger",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: _vm.clearAll,
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-times",
                                                          }),
                                                          _vm._v(
                                                            " Clear All\n                    "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-content-between" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: { click: _vm.previousStep },
                    },
                    [
                      _c("i", { staticClass: "fas fa-arrow-left mr-2" }),
                      _vm._v(" Back\n      "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "success",
                        size: "lg",
                        disabled: !_vm.canGenerateReport || _vm.isGenerating,
                      },
                      on: { click: _vm.debugGenerateReport },
                    },
                    [
                      _vm.isGenerating
                        ? _c("b-spinner", {
                            staticClass: "mr-2",
                            attrs: { small: "" },
                          })
                        : _c("i", { staticClass: "fas fa-play mr-2" }),
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.isGenerating
                              ? "Generating..."
                              : "Generate Report"
                          ) +
                          "\n      "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.currentStep === 3
        ? _c("div", { staticClass: "step-content" }, [
            _c("div", { staticClass: "text-center" }, [
              _c("div", { staticClass: "mb-4" }, [
                _c(
                  "div",
                  { staticClass: "generating-spinner mb-3" },
                  [
                    _c("b-spinner", {
                      staticStyle: { width: "4rem", height: "4rem" },
                      attrs: { variant: "primary" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("h4", { staticClass: "mb-3" }, [
                  _vm._v("\n          Analyzing image(s)\n        "),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("b-overlay", {
        attrs: {
          show: _vm.isLoading,
          rounded: "",
          opacity: "0.6",
          "spinner-variant": "primary",
        },
        scopedSlots: _vm._u([
          {
            key: "overlay",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "text-center p-4" },
                  [
                    _c("b-spinner", { attrs: { label: "Loading..." } }),
                    _vm._v(" "),
                    _c("p", { staticClass: "mt-2" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.loadingMessage) +
                          "\n        "
                      ),
                    ]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("SelectFolderModal", {
        attrs: { mode: _vm.selectFolderMode },
        on: { onSelectedItems: _vm.fileBrowserItemSelected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }